import BaseService from "../BaseService";

class ProductTagService extends BaseService {
    list = async ({ info } = {}) => {
        return await this._api.get("/product_tag/list", { params: { info } });
    };

    get = async (id) => {
        return await this._api.get(`/product_tag/get`, { params: { id } });
    };

    create = async ({ name }) => {
        return await this._api.post(`/product_tag/create`, { name });
    };

    update = async ({ id, name, sort_order, is_visible }) => {
        return await this._api.post(`/product_tag/update`, { id, name, sort_order, is_visible });
    };

    delete = async (id) => {
        return await this._api.post(`/product_tag/delete`, { id });
    };
}

export default ProductTagService;
